import { isArray } from 'util';
import { BaseManufacturingOrder } from '../base-manufacturing-order';

export class BaseManufacturingOrderBuilder {
  static fromJson(json) {
    return (json)
      ? new BaseManufacturingOrder(
        json.hash,
        json.code,
        json.project,
        json.customer,
        json.subCustomer,
        json.reference,
        json.projectNumber,
        json.description,
        json.typeManufacturingOrder,
        json.typeNonProductiveManufacturingOrder
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(BaseManufacturingOrderBuilder.fromJson) : [];
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/base-manufacturing-order.builder.ts